<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('SeaExport.checkPackages')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          config-module="130134"
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'450px'}"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'CheckThePackagesWindow',
  props: {
    visible: { type: Boolean, required: true },
    resultList: { type: Array, required: true, default: () => [] }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('SeaExport.PackageNo'), field: 'packageNo', width: 150 },
        { headerName: this.$t('SeaExport.PackageType'), field: 'packageType', width: 150 },
        { headerName: this.$t('SeaExport.NumberOfPackagesAnticipateOrReality'), field: 'numberOfPackages', width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span style="color:blue">${data.estimatedQuantity}</span> /
                       <span style="color:blue">${data.quantity}</span>`
          } },
        { headerName: 'SKU ' + this.$t('SeaExport.Code3'), field: 'itemNo', width: 150 },
        { headerName: 'SKU ' + this.$t('SeaExport.Quantity2'), field: 'skuNum', width: 150 },
        { headerName: this.$t('SeaExport.TotalNumberOfPackages'), field: 'totalQuantity', width: 150 },
        { headerName: this.$t('SeaExport.LengthAnticipateOrReality'), field: 'length', width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span style="color:blue">${data.estimatedLength}</span> /
                       <span style="color:blue">${data.length}</span>`
          } },
        { headerName: this.$t('SeaExport.WidthAnticipateOrReality'), field: 'width', width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span style="color:blue">${data.estimatedWidth}</span> /
                       <span style="color:blue">${data.width}</span>`
          } },
        { headerName: this.$t('SeaExport.HighAnticipateOrReality'), field: 'high', width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span style="color:blue">${data.estimatedHeight}</span> /
                       <span style="color:blue">${data.height}</span>`
          } },
        { headerName: this.$t('SeaExport.UnitVolumeAnticipateOrReality'), field: 'unitVolume', width: 150,
          cellRenderer: (item) => {
            const { data } = item
            const estimatedUnitCubage = ColumnUtils.number3ColumnLabelFunc(data.estimatedUnitCubage)
            const unitCubage = ColumnUtils.number3ColumnLabelFunc(data.unitCubage)
            return `<span style="color:blue">${estimatedUnitCubage}</span> /
                       <span style="color:blue">${unitCubage}</span>`
          } },
        { headerName: this.$t('SeaExport.GrossWeightAnticipateOrReality'), field: 'grossWeight', width: 150,
          cellRenderer: (item) => {
            const { data } = item
            const estimatedUnitGrossWeight = ColumnUtils.number3ColumnLabelFunc(data.estimatedUnitGrossWeight)
            const unitGrossWeight = ColumnUtils.number3ColumnLabelFunc(data.unitGrossWeight)
            return `<span style="color:blue">${estimatedUnitGrossWeight}</span> /
                       <span style="color:blue">${unitGrossWeight}</span>`
          } },
        { headerName: this.$t('SeaExport.Considerations'), field: 'matters', width: 150 },
        { headerName: this.$t('SeaExport.Anufacturer'), field: 'producerId', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('SeaExport.EstimateLoadingTime'), field: 'estimatedIncomeDate', width: 150 },

        { headerName: this.$t('SeaExport.ActualWarehousingTime'), field: 'actualWarehousingTime', width: 150 },
        { headerName: this.$t('SeaExport.WarehouseNo'), field: 'warehouseNo', width: 150 }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      this.rowData = this.resultList
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

